import { createTheme } from "@mui/material/styles"

/**
 * MUI theme configured to use Arcadia's CSS variables for text colors.
 * This ensures MUI components (e.g. TableSortLabel) display correct
 * colors in both light and dark modes without manual CSS overrides.
 */
export const muiTheme = createTheme({
  components: {
    MuiTableSortLabel: {
      styleOverrides: {
        root: {
          "&.Mui-active": {
            color: "var(--text-primary-color)",
          },
        },
        icon: {
          "&.Mui-active": {
            color: "var(--text-primary-color)",
          },
        },
      },
    },
  },
})
